











import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

import Table from '@/components/Table/Table.vue';

@Component({
	components: {
		Table
	}
})
export default class FilterCard extends Vue {
	@State private rows!: any;
	@State private columns!: any;
	@State private totalRows!: number;
	@State private launcherState!: string;

	@Action private setPreviewState!: any;
	@Action private updatePreview!: any;

	@Prop() private item !: any;

	// private selectedColumn: string = '';

	@Watch('launcherState')
	private getFirstDataView() {
		if (this.launcherState === 'INPUT') {
			this.updatePreview();
		}
	}

	private get selectedColumn() {
		if (this.item) {
			if (this.item.state === 'CHOOSE_COLUMN'
				|| this.item.panel === 'COLUMN') {
				return this.item.id;		
			}
		}
	}
}

